import { Injectable } from "@angular/core";
import {
  AngularFirestore,
  AngularFirestoreCollection,
  CollectionReference,
  Query,
} from "@angular/fire/firestore";

import * as firebase from "firebase/app";
import "firebase/firestore";

import { environment } from "../../environments/environment";
import { User } from "../@core/data/users";
import { UserService } from "../@core/services/user.service";
import { History } from "../models/history.model";

@Injectable({
  providedIn: "root",
})
export class HistoryService {
  visibility = environment.visibility;
  userLogin: User;
  private dbPath = "/shops";

  collRef: AngularFirestoreCollection<History>;

  constructor(private db: AngularFirestore, private userStore: UserService) {
    this.userStore.getCurrentUser().subscribe((user: User) => {
      if (user) {
        this.userLogin = user;
        this.visibility = user.companyId
          ? user.companyId
          : environment.visibility;
      }
    });
  }

  getNewHistories(
    shopId: string,
    uid?: string
  ): AngularFirestoreCollection<History> {
    return this.db.collection(this.dbPath + `/${shopId}/histories`, (ref) =>
      ref
        .where("isDeleted", "==", false)
        .where("isActive", "==", true)
        .where("createdBy", "==", uid)
        .orderBy("updatedOn", "desc")
        .limit(10)
    );
  }

  getCustomerHistories(
    shopId: string,
    customerId: string,
    limit?: number,
    cursor?: any
  ): any {
    var db = firebase.default.firestore();
    var ref = db
      .collection(this.dbPath + `/${shopId}/histories`)
      .where("isDeleted", "==", false)
      .where("isActive", "==", true)
      .where("customerId", "==", customerId)
      .orderBy("updatedOn", "desc");

    ref = limit ? ref.limit(limit) : ref.limit(10);

    if (cursor) {
      ref = ref.startAfter(cursor);
    }

    return ref.get();
  }

  get(shopId: string, id: string) {
    return this.db
      .collection(this.dbPath + `/${shopId}/histories`)
      .doc(id)
      .valueChanges();
  }

  create(history: History): any {
    history.isActive = true;
    history.isDeleted = false;
    history.createdOn = new Date();
    history.createdBy = this.userLogin.uid;
    history.updatedOn = new Date();
    history.updatedBy = this.userLogin.uid;
    history.author = this.userLogin;
    history.visibility = this.visibility;

    history.shopId = history.shopId ? history.shopId : this.userLogin.shopId;
    this.collRef = this.db.collection(
      this.dbPath + `/${history.shopId}/histories`
    );
    return this.collRef.add({ ...history }).then((docRef) => {
      history.id = docRef.id;
      return history;
    });
  }

  update(history: History): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    history.shopId = history.shopId ? history.shopId : this.userLogin.uid;
    this.collRef = this.db.collection(
      this.dbPath + `/${history.shopId}/histories`
    );
    return this.collRef.doc(history.id).update({
      fullName: history.fullName,
      dobYear: history.dobYear ? history.dobYear : 0,
      issueDate: history.issueDate,
      status: history.status,
      value: history.value,
      description: history.description,
      imagesUrl: history.imagesUrl,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
    });
  }

  delete(shopId: string, id: string): Promise<void> {
    const updatedOn = new Date();
    const updatedBy = this.userLogin.uid;
    this.collRef = this.db.collection(this.dbPath + `/${shopId}/histories`);
    return this.collRef.doc(id).update({
      isDeleted: true,
      updatedOn: updatedOn,
      updatedBy: updatedBy,
      timestamp: new Date().getTime(),
    });
  }
}
